import { render, staticRenderFns } from "./importVirAcc.vue?vue&type=template&id=ee985ab8&scoped=true&"
import script from "./importVirAcc.vue?vue&type=script&lang=js&"
export * from "./importVirAcc.vue?vue&type=script&lang=js&"
import style0 from "./importVirAcc.vue?vue&type=style&index=0&id=ee985ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee985ab8",
  null
  
)

export default component.exports